module.exports = __webpack_public_path__ + "img/spain-blood-diseases-male.4b2a207d.png";